import store from "../store/index";
import { loadData , showToast , hideToast } from '@/utils/common'

//预约日期
let reseDate;
//当天预约数据
let reseArr;
//显示的最小/事件下标
let minH = 0, maxH = 0;
let maxReserve = 6, minReserve = 2;

let page_index = 1;
let page_limit = 7;
let day_count = 0;

const Cg = {};

Cg.getResDayList = function(limit,com){
  limit = parseInt(limit);
  let nowDate = new Date();
  var resDayLis = new Array();
  let nowDay = nowDate.getDate();
  for(let i=0;i < limit ;i++){
	nowDate = new Date();
    nowDate.setDate(nowDay + i);
    let y = nowDate.getFullYear();
    let m = nowDate.getMonth() + 1;//获取当前月份的日期
    let m2 = m < 10 ? '0'+m : m;
    let d = nowDate.getDate();
    let d2 = d < 10 ? '0' + d : d;
    let dt = {};
    dt.sDate = m2+'/'+d2;
    dt.pDate = y+'-'+m2+'-'+d2;
    resDayLis.push(dt);
  }
  com(resDayLis);
  //return resDayLis;
}


/**
 * sroomId
 * reseDate
 */
Cg.getResLimitData = function (cgId, reseDate, com) {
  let reseArr = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  var params = {
    "cgId": cgId,
    "reserveDate": reseDate
  }
  showToast();
  loadData('/appCg/queryReserveData',params).then(res => {
    if(res && res.code == 0){
      let maxReserve = res.data.maxReserve;
      let minReserve = res.data.minReserve;
      let mIdxc = minReserve * 2;
      let minH = 16, maxH = 40;
      if (res.data.openHour) {
        let openHour = res.data.openHour;
        let curTime = new Date();
        let curDay = getDateStr(0);
        minH = getIdxByTime(openHour.startHour);
        if (curDay == reseDate) {
          let currStr = curTime.getHours() + ':' + curTime.getMinutes();
          let curIdx = getIdxByTime(currStr);
          if ((minH - curIdx) < 2) {
            minH = curIdx + 2;
          }
        }
        maxH = getIdxByTime(openHour.endHour);
      }

      if (res.data.reserveList && res.data.reserveList.length > 0) {
        let list = res.data.reserveList;
        let startIdx, endIdx, lastEndIdx = 0;
        for (let i = 0; i < list.length; i++) {
          startIdx = getIdxByTime(list[i].startTime);
          endIdx = getIdxByTime(list[i].endTime);
          for (let j = startIdx; j < endIdx; j++) {
            reseArr[j] = 1;
          }
          let startJ = lastEndIdx + 1;  
          if ((startIdx - lastEndIdx) >= mIdxc) {
            startJ = startIdx - mIdxc + 1;
          }
          for (let j = startJ; j < startIdx; j++) {
            if(reseArr[j] == 0){
              reseArr[j] = 2;
            }  
          }
        }
        // var sJ = lastEndIdx + 1;
        // if ((maxH - lastEndIdx) >= mIdxc) {
        //   sJ = maxH - mIdxc + 1;
        // }
        // for (var j = sJ; j < maxH; j++) {
        //   reseArr[j] = 2;
        // }
      }
      var i = maxH - minReserve*2 + 1;
      for (i; i < maxH; i++) {
        if (reseArr[i] == 0) {
          reseArr[i] = 2;
        }
      }
      let limitData = {};
      limitData.minH = minH;
      limitData.maxH = maxH;
      limitData.reseArr = reseArr;
      limitData.maxReserve = maxReserve;
      limitData.minReserve = minReserve;
      com(limitData);
    }
	hideToast();
  }).catch(() => {
    hideToast();
  })
}

/**
 * minH , maxH resArr
 */
Cg.getShowList = function(minH, maxH, reseArr, com) {
  let showList = [];
  for (var i = minH; i < maxH; i++) {
    let dt = {};
    dt.idx = i;
    dt.state = reseArr[i];
    if (reseArr[i] == 1) {
      dt.stateName = '已预约';
    } else if (reseArr[i] == 2) {
      dt.stateName = '不可预约';
    } else {
      dt.stateName = '可预约';
    }
    if (i % 2 == 0) {
      dt.time = (i / 2) + ':00';
    } else {
      dt.time = ((i - 1) / 2) + ':30';
    }
    showList.push(dt);
  }
  com(showList);
  //return showList;
}

Cg.getEndIndex = function (startIndex, maxReserve, reseArr, maxH ,com){
  var endIndex = parseInt(startIndex) + 1;
  var maxR = parseInt(startIndex) + parseInt(maxReserve);
  let res = maxR;
  for (var i = endIndex; endIndex < maxR; endIndex++) {
    if (reseArr[endIndex] == 1 || endIndex == maxH) {
      res = endIndex;
      break;
    }
  }
  com(res);
}

Cg.getTimeByIndex = function (idx,com){
  var time = '';
    if (index % 2 == 0) {
      time = (index / 2) + ":00";
    } else {
      time = ((index - 1) / 2) + ":30";
    }
    if(index <20){
        time = '0'+time;
    }else {
        time = time;
    }
  com(time);
}

// 根据时间获取下标
function getIdxByTime(t) {
  var timeArr = t.split(":");
  var idx = parseInt(timeArr[0] * 2);
  if (parseInt(timeArr[1]) > 0) {
    idx++;
  }
  return idx;
}




/**比较hh:mm 格式的时间大小，t1>t2 返回TRUE  否则返回FALSE **/
function compareTime(t1, t2) {
  var h1 = parseInt(t1.split(":")[0]);
  var h2 = parseInt(t2.split(":")[0]);
  if (h1 < h2) {
    return false;
  } else if (h1 > h2) {
    return true;
  } else {
    var m1 = parseInt(t1.split(":")[1]);
    var m2 = parseInt(t2.split(":")[1]);
    if (m1 <= m2) {
      return false;
    } else {
      return true;
    }
  }
}

//显示当前全部时间段
function showAll() {
  var htmlStr = '';
  if (minH % 2 == 0) {
    if (reseArr[minH] == 1) {
      htmlStr += '<tr><td><ol><li>' + (minH / 2) + ':00</li></ol></td><td class="other">已预约</td></tr>';
    } else if (reseArr[minH] == 2) {
      htmlStr += '<tr><td><ol><li>' + (minH / 2) + ':00</li></ol></td><td style="width:63%;background-color:#f3f3f3;">不可预约</td></tr>';
    } else {
      htmlStr += '<tr><td><ol><li>' + (minH / 2) + ':00</li></ol></td><td style="width:63%;" onclick="reserve(' + minH + ')">可预约</td></tr>';
    }
  } else {
    if (reseArr[minH] == 1) {
      htmlStr += '<tr><td><ol><li>' + parseInt(minH / 2) + ':30</li></ol></td><td class="other">已预约</td></tr>';
    } else if (reseArr[minH] == 2) {
      htmlStr += '<tr><td><ol><li>' + parseInt(minH / 2) + ':30</li></ol></td><td style="width:63%;background-color:#f3f3f3;">不可预约</td></tr>';
    } else {
      htmlStr += '<tr><td><ol><li>' + parseInt(minH / 2) + ':30</li></ol></td><td style="width:63%;" onclick="reserve(' + minH + ')">可预约</td></tr>';
    }
  }

  for (var i = minH + 1; i < maxH; i++) {
    if (i % 2 == 0) {
      if (reseArr[i] == 1) {
        htmlStr += '<tr><td><ol><li>' + (i / 2) + ':00</li></ol></td><td class="other">已预约</td></tr>';
      } else if (reseArr[i] == 2) {
        htmlStr += '<tr><td><ol><li>' + (i / 2) + ':00</li></ol></td><td style="width:63%;background-color:#f3f3f3;">不可预约</td></tr>';
      } else {
        htmlStr += '<tr><td><ol><li>' + (i / 2) + ':00</li></ol></td><td style="width:63%;" onclick="reserve(' + i + ')">可预约</td></tr>';
      }
    } else {
      if (reseArr[i] == 1) {
        htmlStr += '<tr><td><ol><li></li></ol></td><td class="other">已预约</td>';
      } else if (reseArr[i] == 2) {
        htmlStr += '<tr><td><ol><li></li></ol></td><td style="background-color:#f3f3f3;">不可预约</td>';
      } else {
        htmlStr += '<tr><td><ol><li></li></ol></td><td onclick="reserve(' + i + ')">可预约</td>';
      }
    }

  }
  $api.html($api.byId('reserveTable'), htmlStr);
}


function dateAhead(days) {
  var mill = _NOW * 1;
  var ahead = [];
  for (var i = 0; i < days; i++) {
    var aheadMill = mill + 24 * 60 * 60 * 1000 * i;
    var aheadDate = formatDate(aheadMill);
    ahead.push(aheadDate);
  }
  return ahead;
}

function formatDate(mill) {
  var d = new Date(mill);
  var year = d.getFullYear(),
    month = d.getMonth() + 1,
    day = d.getDate(),
    week = d.getDay();
  var hour = d.getHours(),
    minutes = d.getMinutes();
  return {
    year: year,
    month: month,
    day: day,
    week: week,
    hour: hour,
    minutes: minutes
  }
}

function relDate(i, week) {
  var map = ["日", "一", "二", "三", "四", "五", "六"];
  var rel = "";
  if (i == 0)
    rel = "(今天)"
  else if (i == 1)
    rel = "(明天)"
  else
    rel = "(周" + map[parseInt(week)] + ")";
  return rel;
}

const getAhead = function(acount) {
  if(!_orderHoursMax || !_orderHoursMin){
    _orderHoursMin = app.globalData.userInfo.orderHoursMin;
    _orderHoursMax = app.globalData.userInfo.orderHoursMax;
  }
  let aheadCount = acount || 7;
  let d = {
    displayValue: [],
    value: []
  };
  let daah = dateAhead(aheadCount);
  for (let i = 0, len = daah.length; i < len; i++) {
    let item = daah[i];
    let dStr = item["month"] + "月" + item["day"] + "日 " + relDate(i, item["week"]),
        dVal = item["year"] + "-" + item["month"] + "-" + item["day"];
    d["displayValue"].push(dStr);
    d["value"].push(dVal)
  }
  return d;
}


function getMyDay(dateStr) {
  var dateStr1 = dateStr.replace(/-/g, "/");
  var date = new Date(dateStr1);
  var week;
  if (date.getDay() == 0) week = 7;
  if (date.getDay() == 1) week = 1;
  if (date.getDay() == 2) week = 2;
  if (date.getDay() == 3) week = 3;
  if (date.getDay() == 4) week = 4;
  if (date.getDay() == 5) week = 5;
  if (date.getDay() == 6) week = 6;
  return week;
}
function getDateStr(AddDayCount) {
  var dd = new Date();
  dd.setDate(dd.getDate() + AddDayCount);
  var y = dd.getFullYear();
  var m = dd.getMonth() + 1;
  m = m < 10 ? '0'+m : m;
  var d = dd.getDate();
  d = d < 10 ? '0'+d : d;
  return y + "-" + m + "-" + d;
}


// 入座代码开始--------------------
const getWifiInfo = function(com){
  wx.startWifi({
    success:(res) => {
      wx.getConnectedWifi({
        success:(res2) => {
          wx.stopWifi();
          com(res2.wifi.BSSID);
        },
        fail(err2) {
          wx.stopWifi();
          com('');
        }
      });
    },
    fail:(err) => {
      com('');
    }
  });
}

const getIbeaconiInfo = function (com) {
  wx.openBluetoothAdapter({
    success: (res) => {
      startBeaconDiscovery(com);
    },
    fail: (err) => {
      com('');
    }
  })
}


var _discoveryStarted = false;   //是否开始搜索
var t_stop_discovery;          //停止搜索定时器
//开始搜索ibeacon
function startBeaconDiscovery(com) {
  if (_discoveryStarted) {
    com('');
  }else{
    wx.showLoading({
      title: '位置判定中',
      mask: true,
    })
    wx.startBeaconDiscovery({
      uuids: ['FDA50693-A4E2-4FB1-AFCF-C6EB07647826'],
      success:(res) => {
        _discoveryStarted = true
        onBeaconUpdate(com);
        t_stop_discovery = setTimeout(function () {
          stopBeaconDiscovery();
          com('');
        }, 9000);
      },
      fail: (res) => {
        com('');
      }
    });
  }
}

//监听ibeacon设备变化
function onBeaconUpdate(com) {
  wx.onBeaconUpdate(function (res) {
    if (res && res.beacons && res.beacons.length > 0) {
      stopBeaconDiscovery();
      let ssid = res.beacons[0].major + '_' + res.beacons[0].minor;
      com(ssid);
    }
  });
};

var reStopCount = 0; //停止监听重试次数
//停止监听
function stopBeaconDiscovery() {
  if (!_discoveryStarted){
    return;
  }
  clearTimeout(t_stop_discovery);
  wx.stopBeaconDiscovery({
    success: (res) => {
      _discoveryStarted = false;
      reStopCount = 0
      wx.hideLoading();
    },
    fail: (res) => {
      reStopCount++;
      if (reStopCount <= 3) {
        stopBeaconDiscovery();
      } else {
        _discoveryStarted = false;
        reStopCount = 0;
      }
    }
  });
}
// 入座代码结束--------------------



export default Cg;